import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("DOCUMENT "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" MAKER")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Регистрация", -1)
const _hoisted_5 = { class: "form" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Введите E-mail (на него будет отправлен пароль)", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Введите телефон в формате 79008007060", -1)
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginLogo = _resolveComponent("LoginLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginLogo),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: "nevis@yandex.ru",
          maxlength: "50",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: "79008006070",
          maxlength: "11",
          onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event))
        }, null, 512), [
          [_vModelText, _ctx.phone]
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.phone_check == 1)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "main_input",
              placeholder: "Введите код подтверждения",
              maxlength: "6",
              onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone_code) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.phone_code]
            ])
          : _createCommentVNode("", true),
        (!_ctx.step_next)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.check_phone())),
              style: {"margin-left":"10px"},
              disabled: !_ctx.step_phone,
              class: _normalizeClass({ active_btn: _ctx.step_phone })
            }, _toDisplayString(_ctx.name_check_phone), 11, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["hint_left", { red_color: _ctx.phone_check == 0 || _ctx.phone_check == 3 }]),
          style: {"width":"300px"}
        }, _toDisplayString(_ctx.phone_status), 3)
      ]),
      (_ctx.step_next)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button_back",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go_back()))
          }, "Далее"))
        : _createCommentVNode("", true),
      (!_ctx.step_next)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "button_back",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.go_back()))
          }, "Назад"))
        : _createCommentVNode("", true)
    ])
  ]))
}